module.exports = __webpack_public_path__ + "f1be48e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/RecommendCard/default.png
// module id = 1232
// module chunks = 1